<template>
  <div class="body_boxs">
    <!--  -->
    <div class="tab_box">

      <div style="display: flex;">
        <img class="tab_box_img"
          src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/293537d810fbccc1f3f9ee13da6232b9.png" alt="">
        <div class="tab_box_txt_l"><span>保彼通</span><span class="tab_box_txt_r">BobiTon</span></div>
      </div>
      <div class="tab_box_txt">
        <div class="tab_box_txt_cld" @click="router_home">首页</div>
        <div class="tab_box_txt_cld" @click="router_home">产品服务</div>
        <div class="tab_box_txt_cld" @click="router_home">关于我们</div>
        <div class="tab_box_txt_cld" @click="router_home">开放平台</div>
        <div class="tab_box_txt_cld tab_box_txt_cld_box">保彼通APP</div>
      </div>


    </div>
    <div class="w_1200" style="padding-top: 64px;">
      <div>
        <div class="title_txt">保彼通APP上线啦</div>
        <div class="center_swiper">
          <div class="center_swiper_l">
            <div class="center_swiper_l_txt" style="font-weight: 700; font-size: 26px; margin-top: 26px;  line-height: 37px; margin-bottom: 80px;">保彼通是一款互联网直播电商数字分销平台。</div>
            <div class="center_swiper_l_flex_box">
              <div class="center_swiper_l_flex" style="margin-bottom: 50px;">
                <img class="center_swiper_l_img"
                  src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/82d4be30e3ad050847bd83b870a0d57e.png"
                  alt="">
                <div class="center_swiper_l_txt">解决直播电商的分销痛点，并通过数智兵工场的线下场景及自营分销团队实现推品功能。</div>
              </div>
              <div class="center_swiper_l_flex">
                <img class="center_swiper_l_img"
                  src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/82d4be30e3ad050847bd83b870a0d57e.png"
                  alt="">
                <div class="center_swiper_l_txt">为广大商家提供高效便捷的推品服务。</div>
              </div>
              <div class="center_swiper_l_flex">
                <img class="center_swiper_l_img"
                  src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/82d4be30e3ad050847bd83b870a0d57e.png"
                  alt="">
                <div class="center_swiper_l_txt">为平台的所有客户提供免费的数字管理工具服务。</div>
              </div>
              <div class="donow_load_box" style="cursor: pointer;">
                <div class="donow_load"  @click="down_app('ios')">
                 <div class="donow_load_txt"> IOS下载</div>
                 <img class="donow_load_img" src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250529/a0e3721d8c89a0d265cb52d86c29c9d1.png" alt="">
                </div>
                <div class="donow_load" style="margin-left: 30px;"  @click="down_app('Android')">
                 <div class="donow_load_txt"> Android版下载</div>
                 <img class="donow_load_img" src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250529/a0e3721d8c89a0d265cb52d86c29c9d1.png" alt="">
                </div>
              </div>
            </div>
          </div>
          <img class="center_swiper_r"
            src="https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250529/32c2ccf72ce6cb68a705b7065271cdb4.png" alt="">

        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  mounted() {
    if (document.documentElement.clientWidth < 768) {
      this.$router.replace('/')
    }
  },
  methods: {
    router_home(){
      this.$router.push('/')
    },
   	down_app(name) {
			if (name === 'Android') {
				window.location.href = 'https://oss.bobiton.com/__UNI__8920217_0529174049.apk'
			} else {
				this.$message.info('暂未开放～')
			}

		}
  }
}
</script>
<style>
.w_1200 {
  padding: 0 20px;
  width: 1200px;
  margin: auto;
}

.body_boxs {
  width: 100%;
  height: 100vh;
  background-size: 100% 100vh;
  background-image: url('https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250529/de5aa0cd3ee56f8d958070b5e6c07397.png');
}

.tab_box {
  /* margin-bottom: 70px; */
  padding: 0 20px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
  display: flex;
  justify-content: space-evenly;
  /* width: 1200px; */
  margin: auto;
  height: 64px;
  line-height: 64px;
}

.tab_box_txt_l {
  font-weight: 600;
  font-size: 30px;
  color: #000000;
}



.tab_box_img {
  margin-right: 10px;
  width: 36px;
  height: 36px;
  margin-top: 14px;
}

.tab_box_txt {
  cursor: pointer;
  display: flex;
}

.tab_box_txt_cld {
  font-weight: 600;
  font-size: 22px;
  color: #000000;
  margin-left: 90px;
}

.title_txt {
  text-align: center;
  font-weight: 600;
  font-size: 40px;
  color: #000000;
  margin-top: 70px;
}

.center_swiper {
  display: flex;
  justify-content: space-between;
  margin-top: 70px;
}

.center_swiper_l {}

.center_swiper_l_txt {
  width: 644px;
  height: 74px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 26px;
  color: #000000;
  line-height: 37px;
}

.center_swiper_r {
  width: 600px;
  height: 537px;
}

.center_swiper_l_img {
  width: 17px;
  margin-right: 20px;
  margin-top: 7px;
  height: 25px;
}

.center_swiper_l_flex_box {
  margin-top: 40px;
}

.center_box_tab:hover {
  border-radius: 34px;
  background-color: #DEE7FF !important;
}

.center_swiper_l_flex {
  margin-top: 30px;
  display: flex;
}

.center_swiper_l_txt {
  font-weight: 400;
  font-size: 22px;
  color: #333333;
  height: 30px;
}

.center_swiper_box_box {
  margin-bottom: 70px;
  margin-top: 50px;
  display: flex;
  justify-content: space-between;
}

.center_swiper_box {
  border-radius: 22px;
  width: 460px;
  height: 260px;
  background-image: url('https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/651a9ba5c0bc85a551ae417756262daf.png');
  background-size: 100%;
  background-position: center;
  background-repeat: no-repeat;
  transition: background-size 0.3s ease-in-out, background-position 0.3s ease-in-out;
}

.center_swiper_box:hover {
  border-radius: 22px;
  background-size: 120%;
  background-position: center;
}

.center_swiper_box_r {
  width: 690px;
  height: 185px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 26px;
  color: #333333;
  line-height: 37px;
  text-align: left;
  font-style: normal;
  margin-top: 38px;
}

.center_box2 {
  padding-top: 55px;
  background-image: url('https://bbt.dev-hb-bkt.ufozx.com/storage/default/20250325/7b7ba387eab5988eec5adda36175f22f.png');
  background-size: 100% 1055px;
  width: 100%;
  height: 1000px;
}
.donow_load{
  display: flex;
  justify-content: center;
  width: 254px;
  height: 64px;
  line-height: 64px;
  background: linear-gradient( 90deg, #3880F7 0%, #5CA2FE 100%);
border-radius: 34px;
}
.donow_load_txt{
  font-weight: 600;
font-size: 24px;
color: #FFFFFF;
}
.donow_load_img{
  margin-left: 12px;
  margin-top: 17px;
  width: 30px;
  height: 30px;
}
.donow_load_box{
  margin-top: 63px;
  display: flex;
  /* justify-content: space-between; */
}
.tab_box_txt_cld_box {
  color: #3A70F5;
  border-bottom: 4px solid #3A70F5;
}
</style>